// authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { parseJwt } from "@/utils/parseJwt";

export enum LoginStatus {
  INITIAL = "INITIAL",
  AUTHORIZED = "AUTHORIZED",
  UNAUTHORIZED = "UNAUTHORIZED",
}

interface AuthState {
  token: string | undefined;
  loginStatus: LoginStatus;
}

const initialState: AuthState = {
  loginStatus: LoginStatus.INITIAL,
  token: undefined,
};

const cookies = new Cookies();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | undefined>) => {
      if (action.payload) {
        const decodedToken = parseJwt(action.payload);
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp < currentTime) {
          state.loginStatus = LoginStatus.UNAUTHORIZED;
          cookies.remove("token", { path: "/" });
          cookies.remove("inner_token", { path: "/" });
        } else {
          state.token = action.payload;
          state.loginStatus = LoginStatus.AUTHORIZED;
          cookies.set("token", action.payload, { path: "/" });
        }
      } else {
        state.loginStatus = LoginStatus.UNAUTHORIZED;
      }
    },
    setInnerToken: (state, action: PayloadAction<string>) => {
      const token = action.payload;
      const decoded = parseJwt(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decoded.exp < currentTime) {
        cookies.remove("inner_token", { path: "/" });
        return;
      }

      // state.loginStatu s = LoginStatus.AUTHORIZED;
      cookies.set("inner_token", token, { path: "/" });
    },

    logout: (state) => {
      state.token = undefined;
      state.loginStatus = LoginStatus.UNAUTHORIZED;
      cookies.remove("token", { path: "/" });
      cookies.remove("inner_token", { path: "/" });
      localStorage.removeItem("selectedCompany")
      localStorage.removeItem("selectedMarketplace")
      // resetAllState();
    },
    logoutInnerUser: (state) => {
      cookies.remove("inner_token", { path: "/" });

      // admin still authorized
      // state.loginStatus = LoginStatus.AUTHORIZED;
    },

  },
});

export const { setToken, setInnerToken, logout,logoutInnerUser } = authSlice.actions;
export default authSlice.reducer;
                                                                                                                                                                